module.exports = __webpack_public_path__ + "img/167.c9c8957a.jpg";